import React, { FC } from 'react';
import { Spin } from 'antd';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import LocationsOverviewMapToolbar from '../locations_overview_map_toolbar/LocationsOverviewMapToolbar';
import { LocationsViewMode } from '../locations_view_mode_toggle/LocationsViewModeToggle';

interface LocationsReduxDataTableProps {
	viewMode: LocationsViewMode;
	applyFilters: (filters: any) => void;
	clearAndUpdateFilters?: (filters: any, targetCollectionName?: string) => void;
	mapContent: React.ReactNode;
	mapContentLoading?: boolean;
	filterConfig: any[];
	rightActions: React.ReactNode;
	stateSlice: any;
	targetCollectionName: string;
	[key: string]: any;
}

/**
 * Locations overview table with an optional inline map mode.
 * Keeps map-specific ReduxDataTable extensions out of the shared component:
 * - list mode delegates to ReduxDataTable with a custom filter handler
 * - map mode renders the filter toolbar + map content without mounting the table
 */
const LocationsReduxDataTable: FC<LocationsReduxDataTableProps> = ({
	viewMode,
	applyFilters,
	clearAndUpdateFilters,
	mapContent,
	mapContentLoading = false,
	filterConfig,
	rightActions,
	stateSlice,
	targetCollectionName,
	...reduxDataTableProps
}) => {
	if (viewMode === 'map') {
		return (
			<div className="TableHoc px-2">
				<LocationsOverviewMapToolbar
					variant="inline"
					filterConfig={filterConfig}
					updateFilters={applyFilters}
					clearAndUpdateFilters={clearAndUpdateFilters}
					locations={stateSlice}
					targetCollectionName={targetCollectionName}
					rightActions={rightActions}
				/>
				<div
					className="relative"
					style={{
						margin: 0,
						padding: 0,
						background: 'white',
					}}
				>
					{mapContentLoading ? (
						<div className="absolute inset-0 z-10 flex cursor-wait items-center justify-center bg-white/60">
							<Spin size="large" />
						</div>
					) : null}
					{mapContent}
				</div>
			</div>
		);
	}

	return (
		<ReduxDataTable
			filterConfig={filterConfig}
			rightActions={rightActions}
			stateSlice={stateSlice}
			targetCollectionName={targetCollectionName}
			updateFilters={applyFilters}
			{...reduxDataTableProps}
		/>
	);
};

export default LocationsReduxDataTable;
